import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import ConfirmationModal from '../../components/modals/confirmation'

// Copy for each destructive action that needs a confirmation step.
const COPY = {
    suspend: { title: 'platform.companyActions.suspendTitle', message: 'platform.companyActions.suspendMessage', button: 'platform.companyActions.suspend' },
    deactivate: { title: 'platform.userActions.deactivateTitle', message: 'platform.userActions.deactivateMessage', button: 'platform.userActions.deactivate' },
    delete: { title: 'platform.userActions.deleteTitle', message: 'platform.userActions.deleteMessage', button: 'platform.userActions.deleteUser' },
    deletePlan: { title: 'platform.plans.deleteTitle', message: 'platform.plans.deleteMessage', button: 'platform.common.delete' },
}

/**
 * App-style confirmation (the same ConfirmationModal the rest of Soroby uses)
 * for Suspend company / Deactivate user / Delete user / Delete plan.
 *
 * `confirm` is `{ action: 'suspend' | 'deactivate' | 'delete' | 'deletePlan', id, name }` or
 * null when closed; `onConfirm(confirm)` runs the action.
 */
const PlatformConfirm = ({ confirm, onClose, onConfirm }) => {
    const { t } = useTranslation()

    // Keep showing the last request while the modal animates out, so the copy
    // doesn't flash to the generic "Are you sure?" as `confirm` becomes null.
    const last = useRef(confirm)
    if (confirm) last.current = confirm
    const shown = confirm || last.current
    const copy = shown && COPY[shown.action]

    return (
        <ConfirmationModal
            display={!!confirm}
            toggle={onClose}
            title={copy ? t(copy.title) : undefined}
            message={copy ? t(copy.message, { name: shown.name }) : undefined}
            confirmText={copy ? t(copy.button) : undefined}
            cancelText={t('platform.common.cancel')}
            confirmAction={() => confirm && onConfirm(confirm)}
        />
    )
}

export default PlatformConfirm
